export default __webpack_public_path__ + "static/media/hand.264f3ac8.svg";